import { render, staticRenderFns } from "./siteHome.vue?vue&type=template&id=b45c4866"
import script from "./siteHome.vue?vue&type=script&lang=js"
export * from "./siteHome.vue?vue&type=script&lang=js"
import style0 from "./siteHome.vue?vue&type=style&index=0&id=b45c4866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports